<template>
  <div>
    <el-dialog title="选择子公司" :visible.sync="visible" :width="'800px'" :style="{ zIndex: 10000 }">
      <div class="view-filter">
        <el-form ref="form" :model="form" layout="inline">
          <el-row>
            <el-col>
              <el-form-item>
                <el-input v-model="form.search_text" class="search-text" size="small" style="width: 300px"
                  placeholder="请输入系统编码/档案名称">
                  <el-button slot="append" @click="onSearch">查找</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div>
        <div class="box left">
          <div class="header">未选：{{ left.length }}</div>
          <div class="list-body">
            <ul class="list-content">
              <li class="list-item list-header">
                <span>系统编码</span>
                <span>档案名称</span>
              </li>
              <!-- :class="[forbidden ? 'forbidden' : '', 'list-item']" -->
              <li class="list-item" v-for="item in left" :key="item.client_id + Math.random()"
                @click="leftSelect(item.client_id)">
                <span>{{ item.ys_code }}</span>
                <span>{{ item.ys_name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="box middle">
          <el-button type="primary" :style="buttonStyle" :size="'small'" @click="selectAll" :disabled="selectedAll">
            全选
          </el-button>
          <el-button type="primary" :style="buttonOneStyle" :size="'small'" @click="removeAll">
            清空
          </el-button>
        </div>
        <div class="box right">
          <div class="header">
            已选：{{
              right.length == 1 && right[0].ys_code == "全部"
                ? right[0].client_id.length
                : right.length
            }}
          </div>
          <div class="list-body">
            <ul class="list-content">
              <li class="list-item list-header right">
                <span>系统编码</span>
                <span>档案名称</span>
              </li>
              <li class="list-item right" v-for="item in right" :key="item.client_id + Math.random()"
                style="display: flex">
                <span>{{ item.ys_code }}</span>
                <span>{{ item.ys_name }}</span>
                <i style="
                    cursor: pointer;
                    position: relative;
                    left: 21px;
                    top: 11px;
                  " class="el-icon-close" @click="rightDelete(item)"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <a-pagination
        v-if="totalPage > 1"
        showQuickJumper
        size="small"
        :pageSize="20"
        :defaultCurrent="currentPage"
        :total="totalCount"
        @change="onChangePage"
        style="margin-top: 10px;"
      /> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { SplitgetSplitFileInfo } from "@/api/index";
export default {
  name: "SelectSummyModal",
  beforeCreate() { },
  data() {
    return {
      buttonStyle: {
        display: "block",
        marginBottom: "4px",
      },
      buttonOneStyle: {
        display: "block",
        marginBottom: "4px",
        marginLeft: "1px",
        marginTOP: "10px",
      },
      province_id: "",
      searchText: "",
      visible: false,
      left: [],
      right: [{ ys_code: "" }],
      assessList: [],
      allGoodsClassList: [],
      clientLevelList: [],
      regionList: [],
      number: 10,
      currentPage: "",
      totalCount: "",
      totalPage: 1,
      fileType: 2,
      oldFileType: 2,
      is_showData: true,
      forbidden: false, //是否可选
      form: {
        search_text: "",
        is_subsidiary_unique: "1"
      },
      selectedAll: false
    };
  },
  props: {
    clientId: {
      type: Number,
    },
  },
  async created() {
    await this._getPage(1);
  },
  methods: {
    openModal(info) {
      this.info = { ...info };
      console.log(this.info);
      this.right = info ? info : [];
      this.visible = true;
      this._getPage(1);
    },
    //获取列表
    async _getPage(page) {
      console.log(this.form.search_text)
      await SplitgetSplitFileInfo(
        this.form.search_text,
        this.clientId,
        "1,3"
      ).then((res) => {
        if (0 === res.status) {
          this.selectedAll = false;
          let listarr = res.data.subsidiary;
          for (const iterator of listarr) {
            iterator.client_id = iterator.ys_id;
          }
          let list = listarr;
          this.allGoodsClassList = [...list];
          let info = JSON.parse(JSON.stringify(this.right));

          for (let i = 0; i < info.length; i++) {
            let id = info[i].client_id;
            let index = list.findIndex((item) => item.client_id === id);
            if (index != -1) {
              list.splice(index, 1);
            }
          }
          this.left = [...list];
          this._filterLeft();
          // this.totalCount = res.data.totalCount;
          // this.currentPage = parseInt(res.data.currentPage);
          // this.totalPage = res.data.totalPage;
        } else {
          this.left = [];
        }
      });
    },
    onSearch(val) {
      this._getPage(1);
    },
    leftSelect(id) {
      if (this.forbidden) {
        return;
      }
      // if (this.number != -1) {
      //   if (this.right.length > this.number-1) {
      //         this.$message.warning('最多选择'+ this.number+'个档案')
      //       return
      //     }
      // }

      const left = this.left;
      const target = left.filter((item) => item.client_id === id)[0];
      this.right.push(target);
      this.left = left.filter((item) => item.client_id !== id);
    },
    rightDelete(item) {
      if (item.subsidiary_name != "全部") {
        const right = this.right;
        const target = right.filter((item1) => item1.client_id === item.client_id)[0];
        this.right = right.filter((item1) => item1.client_id !== item.client_id);
        if (!this.forbidden) {
          this.left.push(target);
        }
        if (this.right.length == 0) {
          this.forbidden = false;
          // this.oldFileType = this.fileType
        }
      } else {
        this.removeAll();
      }
    },
    save() {
      this.info = [...this.right];
      this.$emit("save", this.info);
      this.visible = false;
    },
    _filterLeft() {
      let right = this.right;
      let rightIds = [];
      for (let item of right) {
        if (typeof item.client_id == "object") {
          for (let y of item.client_id) {
            rightIds.push(y);
          }
        } else {
          rightIds.push(item.client_id);
        }

        if (right[0].subsidiary_name == "全部") {
          this.left = [];
          this.selectedAll = true;
        }
      }
      this.left = this.left.filter(
        (item) => rightIds.indexOf(item.client_id) === -1
      );
    },
    selectAll() {
      this.is_showData = true;
      this.selectedAll = true;
      this.right = [
        {
          client_id: this.left.map((item) => item.client_id),
          ys_code: "全部",
          subsidiary_code: "",
          subsidiary_name: "全部",
        },
      ];
      this.left = [];
    },
    removeAll() {
      this.is_showData = false;
      this.selectedAll = false;
      this.right = [];
      this.left = this.allGoodsClassList;
    },
    onChangePage(pageNumber) {
      this._getPage(pageNumber);
    },
    //取消
    cancel() {
      let obj = this.info;
      let arr = [];
      for (let i in obj) {
        arr.push(obj[i]);
      }
      this.$emit("save", arr);
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.icon-close {
  position: absolute;
  right: 9px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;

  &:hover {
    color: #000;
  }
}

.box {
  display: inline-block;
  vertical-align: middle;

  &.left,
  &.right {
    position: relative;
    padding-top: 34px;
    width: 330px;
    height: 400px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;

    .header {
      padding: 6px 12px;
      border-radius: 4px 4px 0 0;
      background: #fff;
      color: rgba(0, 0, 0, 0.65);
      border-bottom: 1px solid #e8e8e8;
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .list-body {
      position: relative;
      height: 100%;
      font-size: 14px;

      .list-content {
        padding: 0;
        padding-top: 42px;
        height: 100%;
        overflow: auto;
        list-style: none;
        margin: 0;
      }
    }
  }

  &.left {
    .list-item {
      cursor: pointer;
    }
  }

  &.middle {
    overflow: hidden;
    margin: 0 8px;
  }
}

.view-filter {
  margin-bottom: 20px;
}

.list-item {
  position: relative;
  overflow: hidden;
  /*white-space: nowrap;*/
  text-overflow: ellipsis;
  min-height: 32px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  list-style: none;

  &:hover {
    background-color: #e6f7ff;
  }

  span {
    display: inline-block;
    vertical-align: middle;
    padding: 10px;
    width: 49%;

    /*overflow: hidden;*/
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
    &:last-of-type {
      width: 50%;
    }
  }

  &.right {
    padding-right: 32px;
  }
}

.list-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  z-index: 2;

  span {
    background: #fafafa;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
  }
}

.forbidden {
  color: #b0b0b0;
  cursor: not-allowed !important;
}
</style>
